import { APPS, INVOICES, SERVICE_ITEMS, WORKORDERS } from 'components/constants';
import * as toolbox from '../components/common/toolbox';
import * as types from './action-types';
import firebase from 'firebase/compat/app';

const firestore = firebase.firestore();
const _ = require('lodash');

/*-----------------------------------------------*/
/*  INVOICES
/*-----------------------------------------------*/

export function clearInvoices() {

	return dispatch => {

		dispatch({ type: types.INVOICES + '_CLEAR' });

	}
}
export function subInvoice(handle, id) {

	return dispatch => {

		dispatch({ type: types.INVOICE + '_PENDING' });

		const unsubscribe = firestore.collection(handle + '/invoices/invoices').doc(id).onSnapshot((doc) => {
			var invoice = { ...doc.data(), id: doc.id };

			// Add the service items to the inventory store
			if (invoice.serviceItems?.length) {
				for (var serviceItem of invoice.serviceItems) {
					firestore.collection(handle + '/inventory/inventory/service-items/service-items').doc(serviceItem.serviceItemId).get().then((doc) => {
						dispatch({ type: types.SERVICE_ITEMS + '_ADD', data: { ...doc.data(), id: doc.id } });
					});
				}
			}

			dispatch({ type: types.INVOICE + '_FULFILLED', data: invoice, unsubscribe });
		});
	}
}
export function subInvoicesByField(handle, field, value, prefix) {

	return dispatch => {

		dispatch({ type: ((prefix) ? prefix + '_' : '') + types.INVOICES + '_PENDING' });

		var unsubscribe = firestore.collection(handle + '/invoices/invoices').where(field, '==', value).where('deleted', '==', false).onSnapshot((querySnapshot) => {

			var invoices = [];
			querySnapshot.forEach((doc) => {
				invoices.push({ ...doc.data(), id: doc.id });
			});
			invoices = _.orderBy(invoices, ['modified'], ['desc']);

			dispatch({ type: ((prefix) ? prefix + '_' : '') + types.INVOICES + '_FULFILLED', data: invoices, unsubscribe });
		});
	};
}
export function subDashboardInvoices(handle, appId, widget_id) {

	return async dispatch => {

		dispatch({ type: types.INVOICES_DASHBOARD + '_CLEAR' });
		dispatch({ type: types.INVOICES_DASHBOARD + '_PENDING' });

		let type = _.find(Object.values(APPS), { id: appId }).requestType;
		
		var query = firestore.collection(handle + '/invoices/invoices').where('type', '==', type).where('deleted', '==', false);

		if (widget_id == 'invoice-drafts') query = query.where('statusId', '==', INVOICES.DRAFT.id);
		if (widget_id == 'invoice-pending') query = query.where('statusId', '==', INVOICES.SENT.id);
		if (widget_id == 'invoice-partial') query = query.where('statusId', '==', INVOICES.PARTIAL.id);
		if (widget_id == 'invoice-overdue') query = query.where('statusId', '==', INVOICES.OVERDUE.id);

		var unsubscribe = query.onSnapshot(async(querySnapshot) => {
			var invoices = [];
			querySnapshot.forEach((doc) => {
				invoices.push({ ...doc.data(), id: doc.id });
			});
			invoices = _.orderBy(invoices, ['requestDate'], ['desc']);

			dispatch({ type: types.INVOICES_DASHBOARD + '_FULFILLED', data: invoices, unsubscribe });
		});
	};
}
export function clearDashboardInvoices() {

	return dispatch => {
		dispatch({ type: types.INVOICES_DASHBOARD + '_CLEAR' });
	};
}
export function subInvoicesByWorkOrderID(handle, work_order_id) {

	return dispatch => {

        if (work_order_id) {
			dispatch({ type: types.WORK_ORDER_INVOICES + '_CLEAR' });
			dispatch({ type: types.WORK_ORDER_INVOICES + '_PENDING' });
			
			firestore.collection(handle + '/work-orders/work-orders').doc(work_order_id).get().then((doc) => {
                var unsubscribe = firestore.collection(handle + '/invoices/invoices').where('customId', '==', doc.data()['customId']).where('deleted', '==', false).onSnapshot((querySnapshot) => {
    
                    var invoices = [];
                    querySnapshot.forEach((doc) => {
                        invoices.push({ ...doc.data(), id: doc.id });
                        
                    });
                    invoices = _.orderBy(invoices, ['modified'], ['desc']);
                    
    
                    dispatch({ type: types.WORK_ORDER_INVOICES + '_FULFILLED', data: invoices, unsubscribe });
                });
            });
		}
	}
}
export function createInvoicePdf(options, callback) {
	return async dispatch => {
		try {
			// firebase.functions().useEmulator('localhost', 5001);
			firebase.functions().httpsCallable('createInvoicePdf')(options).then((result) => {
				if (typeof callback === 'function') callback(result);
			}).catch((error) => {
				console.log(error);
			});
		} catch (error) {
			window.toastr.error(error, "Error Creating Invoice");
		}
	};
}
export function createPaymentReceiptPdf(options, callback) {
	return async dispatch => {
		firebase.functions().httpsCallable('createReceiptPdf')(options).then((result) => {
			if (typeof callback === 'function') callback(result);
		}).catch((error) => {
			console.log(error);
		});
	};
}
export function createInvoice({
	activeTaxRates, 
	appId, 
	depositInvoices,
	handle, 
	lineItems, 
	request_id, 
	user, 
	workOrders, 
	callback,
}) {

	return async dispatch => {

		dispatch({ type: types.INVOICE + '_SAVE_PENDING' });

		const batch = firestore.batch();
		const invoiceId = await nextInvoiceId(handle, batch);

		const doc = await firestore.collection(handle + '/service-requests/service-requests').doc(request_id).get();
		const serviceRequest = { ...doc.data(), id: doc.id };

		var serviceItems = [];
		var taxRateId = null;
		var memoArray = [];

		if (workOrders) {
			workOrders.forEach((wo) => {
				memoArray.push('Work Order #' + wo['customId']);
			});
	
			for (let workOrder of workOrders) {
				batch.update(firestore.collection(handle + '/work-orders/work-orders').doc(workOrder.id), { statusId: WORKORDERS.INVOICED.id });
	
				if (workOrder.taxRateId) taxRateId = workOrder.taxRateId; // If any Work Order has Tax Rate set, use this for Invoice
	
				const itemsDoc = await firestore.collection(`${handle}/work-orders/work-orders/${workOrder.id}/serviceItems`).doc(workOrder.id).get();
				if (itemsDoc.exists) serviceItems = [...serviceItems, ...itemsDoc.data()['serviceItems']];
	
				const attachDoc = await firestore.collection(`${handle}/work-orders/work-orders/${workOrder.id}/external_invoices`).doc(workOrder.id).get();
				const attachments = (attachDoc.exists) ? { ...attachDoc.data().external_invoices } : [];
				const extInvoices = _.filter(attachments, (o) => o.price);
	
				extInvoices.forEach((attach, index) => {
					serviceItems.push({
						_noEdit: true,
						calculatedPrice: attach.price,
						count: 1,
						id: 'external',
						name: attach.name,
						option: 0,
						price: attach.price,
						taxable: false,
						type: 'external',
					});
				});
			}
		}

		// Apply Deposit Invoices
		if (depositInvoices && depositInvoices.length) {
			let totalDepositAmount = 0;
			depositInvoices.forEach((inv) => {
				totalDepositAmount += inv.totals?.grandTotal || 0;
				memoArray.push('Deposit from Invoice #' + inv.customId);
				batch.set(firestore.collection(handle + '/invoices/invoices').doc(inv.id), { isDepositApplied: true }, { merge: true });
			});
		
			if (totalDepositAmount > 0) {
				serviceItems.push({
					id: "deposit-applied",
					type: SERVICE_ITEMS.DISCOUNT.id,
					name: 'Deposit Applied',
					price: totalDepositAmount,
				});
			}
		}
		
		let taxRate = (taxRateId) ? activeTaxRates?.find((rate) => rate.rateId == taxRateId)?.rate ?? activeTaxRates[taxRateId]?.rate ?? 0 : 0;
		const totals = toolbox.calculatedTotals(serviceItems, null, taxRate);

		var invoice = {
			_address: serviceRequest._address ?? '',
			_displayName: serviceRequest._displayName ?? '',
			_description: serviceRequest.description ?? '',
			billTo: '...',
			serviceTo: '...',
			customId: serviceRequest.customId,
			requestId: serviceRequest.id,
			customerId: serviceRequest.customerId,
			...(appId == APPS.ASSETS.id) ? { assetTypeId: serviceRequest.assetTypeId} : {},
			...(appId == APPS.ASSETS.id) ? { assetId: serviceRequest.assetId } : {},
			sendToContactId: null,
			memo: memoArray.join(', '),
			serviceItems: lineItems || serviceItems,
			payments: [],
			paymentsTotal: 0,
			deleted: false,
			invoiceDate: new Date(),
			created: new Date(),
			modified: new Date(),
			ownerId: user.contact?.email,
			statusId: INVOICES.DRAFT.id,
			taxRateId: taxRateId,
			totals: totals,
			type: serviceRequest.type,
			...(workOrders) ? { workOrders: workOrders.map((wo) => ({ id: wo.id, customId: wo.customId })) } : {},
		};

		batch.set(firestore.collection(handle + '/invoices/invoices').doc(invoiceId), { ...invoice });
		batch.set(firestore.collection(handle + '/profiles/profiles').doc(serviceRequest.customerId), { modified: new Date() }, { merge: true });

		batch.commit().then(() => {
			dispatch({ type: types.INVOICE + '_SAVE_FULFILLED' });
			window.toastr.success('The Invoice has been successfully saved/updated', 'Invoice Saved!');
			if (typeof callback === 'function') callback(invoiceId);

		}).catch((error) => {
			toolbox.process_error(error, 'Record NOT Saved!');
		});
	};
}
export function updateInvoice(handle, invoiceId, update, callback, silent) {

	return async dispatch => {
		const batch = firestore.batch();
		batch.update(firestore.collection(handle + '/invoices/invoices').doc(invoiceId), { ...update, modified: new Date() });
		batch.commit().then(() => {
			dispatch({ type: types.INVOICE + '_SAVE_FULFILLED' });
			if (!silent) window.toastr.success('The Invoice has been successfully saved/updated', 'Invoice Saved!');
			if (typeof callback === 'function') callback();

		}).catch((error) => {
			toolbox.process_error(error, 'Record NOT Saved!');
		});
	};
}
export function deleteInvoice(handle, invoice, callback) {

	return async dispatch => {

		dispatch({ type: types.INVOICE + '_SAVE_PENDING' });
		
		const batch = firestore.batch();

		if (invoice.workOrders && invoice.workOrders.length) for (let workOrder of invoice.workOrders) {
			batch.update(firestore.collection(handle + '/work-orders/work-orders').doc(workOrder.id), { statusId: WORKORDERS.COMPLETE.id });
		}
		batch.update(firestore.collection(handle + '/invoices/invoices').doc(invoice.id), { deleted: true });

		batch.commit().then(() => {
			dispatch({ type: types.INVOICE + '_SAVE_FULFILLED' });
			window.toastr.success('The Invoice has been successfully deleted', 'Invoice Deleted!');
			if (typeof callback === 'function') callback();
		}).catch((error) => {
			toolbox.process_error(error, 'Record NOT Saved!');
		});
	};
}

/*-----------------------------------------------*/
/*  PAYMENTS
/*-----------------------------------------------*/

export function saveNewPayment(handle, paymentObject, openBalance, amountPaying, callback) {

	return async dispatch => {

		dispatch({ type: types.PAYMENTS + '_SAVE_PENDING' });

		const batch = firestore.batch();
		const paymentId = await nextPaymentId(handle, batch);

		// Update selected invoices
		for (let inv of paymentObject.invoices) {
			const invoiceObject = {
				payments: [ ...inv?.payments ?? [], 
					...(inv.payment > 0) ? [{
						amount: (inv.payment < inv.openBalance) ? parseFloat(inv.payment.toFixed(2)) : parseFloat(inv.openBalance.toFixed(2)),
						checkNumber: paymentObject.checkNumber || '',
						date: new Date(),
						method: paymentObject.method,
						paymentId, 
					}] : []
				],
			};
			invoiceObject.paymentsTotal = invoiceObject.payments.reduce((a, b) => a + parseFloat(b.amount), 0);
			invoiceObject.statusId = (amountPaying >= openBalance) ? INVOICES.PAID.id : INVOICES.PARTIAL.id;
			batch.set(firestore.collection(handle + '/invoices/invoices').doc(inv.id), { ...invoiceObject }, { merge: true });
		}

		paymentObject.invoices = paymentObject.invoices.filter((inv) => inv.payment).map((inv) => ({ id: inv.id, amount: parseFloat(inv.payment.toFixed(2)) }));

		// Save Payment Object
		batch.set(firestore.collection(handle + '/payments/payments').doc(paymentId), { ...paymentObject, modified: new Date() });
		batch.set(firestore.collection(handle + '/service-requests/service-requests').doc(paymentObject.requestId), { modified: new Date() }, { merge: true });
		batch.set(firestore.collection(handle + '/profiles/profiles').doc(paymentObject.customerId), { modified: new Date() }, { merge: true });

		batch.commit().then(() => {
			dispatch({ type: types.PAYMENTS + '_SAVE_FULFILLED' });
			window.toastr.success('The Payment has been successfully received', 'Payment Received!');
			if (typeof callback === 'function') callback(paymentId);

		}).catch((error) => {
			toolbox.process_error(error, 'Payment NOT Received!');
		});
	};
}
export function deletePayment(handle, paymentId, taxRates, callback) {

	return async dispatch => {

		// dispatch({ type: types.PAYMENTS + '_SAVE_PENDING' });

		// const batch = firestore.batch();

		// // Get payment doc
		// var payment = await firestore.collection(handle + '/payments/payments').doc(paymentId).get();
		// payment = { ...payment.data(), id: payment.id };

		// // Get invoices paid by this payment, update their statusId and applied
		// const invoicesPaid = payment.invoices;
		// for (let inv of invoicesPaid) {
		// 	// Get Invoice 
		// 	var invoice = await firestore.collection(handle + '/invoices/invoices').doc(inv.id).get();
		// 	invoice = { ...invoice.data(), id: invoice.id };
		// 	var invoiceObject = {
		// 		applied: parseFloat(invoice.applied) - parseFloat(inv.amount),
		// 		payments: invoice.payments.filter((p) => p != paymentId),
		// 	};
		// 	const totalAmount = invoice.serviceItems.reduce((a, b) => {
		// 		return a + ((b.taxable && invoice.taxRateId) ? (((taxRates?.find((rate) => rate.rateId == invoice.taxRateId).rate * parseFloat(b.calculatedPrice)) + parseFloat(b.calculatedPrice))) : parseFloat(b.calculatedPrice));
		// 	}, 0);
		// 	if (invoiceObject.applied < totalAmount) {
		// 		invoiceObject.statusId = INVOICES.PARTIAL.id;
		// 	};
		// 	batch.set(firestore.collection(handle + '/invoices/invoices').doc(inv.id), invoiceObject, { merge: true });
		// }

		// // Delete payment
		// batch.set(firestore.collection(handle + '/payments/payments').doc(paymentId), { deleted: true, modified: new Date() }, { merge: true });

		// batch.commit().then(() => {
		// 	dispatch({ type: types.PAYMENTS + '_SAVE_FULFILLED' });
		// 	window.toastr.success('The Payment has been successfully deleted', 'Payment Deleted!');
		// 	if (typeof callback === 'function') callback(paymentId);

		// }).catch((error) => {
		// 	toolbox.process_error(error, 'Payment NOT Deleted!');
		// });
	};
}
export function subPaymentsByField(handle, field, value) {

	return dispatch => {

		dispatch({ type: types.PAYMENTS + '_PENDING' });

		var unsubscribe = firestore.collection(handle + '/payments/payments').where(field, (field == 'invoices') ? 'array-contains' : '==', value).where('deleted', '==', false).onSnapshot((querySnapshot) => {

			var payments = [];
			querySnapshot.forEach((doc) => {
				payments.push({ ...doc.data(), id: doc.id });
			});
			payments = _.orderBy(payments, ['modified'], ['desc']);

			dispatch({ type: types.PAYMENTS + '_FULFILLED', data: payments, unsubscribe });
		});
	};
}
export function subPaymentsById(handle, paymentId) {

	return dispatch => {

		dispatch({ type: types.PAYMENT + '_PENDING' });

		const unsubscribe = firestore.collection(handle + '/payments/payments').doc(paymentId).onSnapshot((doc) => {
			var payment = { ...doc.data(), id: doc.id };

			dispatch({ type: types.PAYMENT + '_FULFILLED', data: payment, unsubscribe });
		});
	};
}
export function clearPayments() {

	return dispatch => {

		dispatch({ type: types.PAYMENTS + '_CLEAR' });
	};
}
async function nextInvoiceId(handle, batch) {
	const table = 'invoices';
	const field = 'nextInvoiceId';
	const startingId = 100000;

	return toolbox.nextId(handle, batch, table, field, startingId);
}
async function nextPaymentId(handle, batch) {
	const table = 'payments';
	const field = 'nextPaymentId';
	const startingId = 11000;

	return toolbox.nextId(handle, batch, table, field, startingId);
}
